import { isOwnBrand } from 'Common/utilities/brandingCategory';

export const shouldNotSetSidebarDefaultLogo = (
  brandingCategoryId,
  isOnboarding,
) => {
  return !!(isOwnBrand(brandingCategoryId) || isOnboarding);
};
